export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8071.335b4302.jpg";